// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PDragOutlinedSvg from "@fishx/icons-svg/es/asn/PDragOutlined";
import FishxIcon from '../components/FishxIcon';

var PDragOutlined = function PDragOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PDragOutlinedSvg
  }));
};

PDragOutlined.displayName = 'PDragOutlined';
export default React.forwardRef(PDragOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PDragOutlined.js
// module id = 3352
// module chunks = 0